import { ILCHttpResponse, IPaginationRequest, IPaginationResponse } from '@logicalcommander/types'
import { createApi } from '@reduxjs/toolkit/query/react'
import { v4 as uuidv4 } from 'uuid'
import { configManager } from '../../config/configManager'
import { IActivityLogSummary } from '../pages/Security/ActivityLog/ActivityListColumns'
import { RootState } from '../redux/store'
import { createBaseQueryWithErrorHandling } from './baseQueryWithErrorHandling'

export interface IActivityLogEntry {
  identity: string
  ipAddress: string
  fullName: string
  roles: string
  outcome: string
  details: {
    action: string
  }
  createdAt: Date
}

export const activityLogApi = createApi({
  reducerPath: 'activityLogApi',
  baseQuery: createBaseQueryWithErrorHandling(`${configManager.api.GATEWAY_URL}/activity`, (headers, { getState }) => {
    headers.set('x-request-id', uuidv4())
    const { token, companyToken } = (getState() as RootState).authReducer
    if (token) {
      headers.set('authorization', `Bearer ${token}`)
    }
    if (companyToken) {
      headers.set('x-company-token', companyToken)
    }
    return headers
  }),
  endpoints: (builder) => ({
    getLog: builder.mutation<IPaginationResponse<IActivityLogSummary[]>, IPaginationRequest>({
      query: ({ pageIndex, pageSize, search, sortBy }) => {
        return {
          url: '/log',
          method: 'POST',
          body: {
            pageIndex,
            pageSize,
            sortBy,
            search,
          },
        }
      },
      transformResponse: (rawResult: ILCHttpResponse<IPaginationResponse<IActivityLogSummary[]>>) => {
        return rawResult.data as IPaginationResponse<IActivityLogSummary[]>
      },
    }),
  }),
})

export const { useGetLogMutation } = activityLogApi
